import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

const useResendInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (id: number) =>
      api.call(`/invitations/${id}/resend`, {
        method: "POST",
        root: supportApiBase,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.invitations());
      },
    }
  );
};

export default useResendInvitation;
